import { useState } from 'react'
import { ComponentProps } from '@/types/util'
import { GalleryItem } from '@/types/models'
import {
  PropertyMosaicVariantProps,
  propertyMosaic
} from './property-mosaic.variants'

export type usePropertyMosaicProps = ComponentProps<
  GalleryItem[],
  PropertyMosaicVariantProps
>

export const usePropertyMosaic = (props: usePropertyMosaicProps) => {
  const { className = '', data } = props
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1
  })

  const styles = propertyMosaic()

  const openLightboxImage = (index: number) => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: index
    })
  }

  const getGridClass = (index: number) => {
    const group = Math.floor(index / 4)
    const positionInGroup = index % 4

    if (data.length === 1) {
      return 'col-span-6 row-span-2'
    }

    if (data.length === 2) {
      return 'col-span-3 row-span-2'
    }

    let cardClasses = 'col-span-2 row-span-1'

    if (group % 2 === 0) {
      if (positionInGroup === 0 || positionInGroup === 3) {
        cardClasses = 'col-span-2 row-span-2'
      }
    } else {
      if (positionInGroup === 1 || positionInGroup === 2) {
        cardClasses = 'col-span-2 row-span-2'
      }
    }

    return cardClasses
  }

  return {
    className,
    styles,
    getGridClass,
    lightboxController,
    openLightboxImage,
    data
  }
}
